import React, { useState, useEffect, use } from 'react';
import './ProductPage.scss'; // Подключаем стили
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { miniApp } from '@telegram-apps/sdk-react';
import { useNavigate, useParams } from "react-router-dom";
import { useMainButton } from '../../hooks/useMainButton';
import { FreeMode } from 'swiper/modules';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import LoaderBlock from '../../components/ui/LoaderBlock';
import api from "../../api";
import { useCurrency } from '../../contexts/CurrencyContext';
import ApiImage from '../../components/ApiImage';
import DeliveryIcon from '../../components/ui/DeliveryIcon';
import { useCart } from '../../contexts/CartContext';

const ProductPage = () => {
  const {
      cartItems,
      removeFromCart,
      addToCart,
      updateQuantity,
      openModal
    } = useCart();
  const { id } = useParams();
  const navigate = useNavigate();
  const { cny } = useCurrency();
  useMainButton();
  const [quantity, setQuantity] = useState(10);
  const [inCart, setInCart] = useState(false);
  const { action, clear } = useBackButtonManager();
  const [isLoad, setIsLoad] = useState(true);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    setIsLoad(true);
    window.scrollTo(0, 0);
    miniApp.setBackgroundColor('#1D1D20');
    miniApp.setHeaderColor('#1D1D20');
    action(() => window.history.back());
    const fetchProduct = async () => {
        try {
            const response = await api.get(`/api/products/UserProduct?id=${id}`);
            const data = response.data;
            setProduct(data);
            setIsLoad(false);
        } catch (error) {
            console.error("Ошибка при загрузке товаров:", error);
        }
    };
    fetchProduct();
    return () => {
      clear();
    };
  }, []);

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 1) {
      setQuantity(value);
    }
  };

  const increase = () => {
    const newQty = quantity + 1;
    setQuantity(newQty);
    updateQuantity(product.id, newQty);
  };

  const decrease = () => {
    setQuantity((prev) => {
      const newValue = prev - 1;

      if (newValue <= 0) {
        removeFromCart(product.id);
        setInCart(false); // если используешь inCart
        return 1; // или можно вернуть 0, если хочешь отобразить как 0
      }

      updateQuantity(product.id, newValue);
      return newValue;
    });
  };

  const handleQuantityChange = (e) => {
    const val = e.target.value;

    // Если пустое — просто показать его, не обновлять cart
    if (val === "") {
      setQuantity(""); // или setQuantity(val)
      return;
    }

    const value = parseInt(val, 10);

    if (isNaN(value)) return;

    if (value <= 0) {
      removeFromCart(product.id);
      setInCart(false);
      setQuantity(""); // оставить пустым
      return;
    }

    setQuantity(value);
    updateQuantity(product.id, value);
  };



  const handleAddToCart = () => {
    addToCart({id: product.id, quantity: quantity});
  };

  useEffect(() => {
    if (product) {
      const item = cartItems.find((i) => i.id === product.id);
      if (item) {
        setQuantity(item.quantity);
        setInCart(true);
      } else {
        setQuantity(1);
        setInCart(false);
      }
    }
  }, [cartItems, product]);

  return (
    <div className={`product-page ${!isLoad && "page-classes"}`}>
      {isLoad ? (<LoaderBlock iconSize={32} minHeight={"100vh"} />) : (
        <>
        <div className='product-info-page'>
        <Swiper
          modules={[FreeMode]}
          spaceBetween={8}
          slidesPerView={1}
          freeMode={false}
          pagination={{ clickable: true }}
        >
          <SwiperSlide style={{ width: "100%" }}>
            <ApiImage path={product.mainImage} className='slide-image'></ApiImage>
          </SwiperSlide>
        </Swiper>
        <div className='description-container'>
          <div className='product-amount-container'>
            <div className='product-amount'>{product.cost.toFixed(2)} ¥</div>
            <div className='product-convert-amount'>~ {Math.round(product.cost * cny)} ₽</div>
          </div>
          <div className='product-title'>
            {product.name}
          </div>
        </div>
      </div>
      {product.description != undefined && product.description != null ? (
        <div className='description-container'>
          <div className='title'>Комментарий к товару</div>
          <div className='description'>
            {product.description}
          </div>
        </div>
      ) : (<></>)}
      
      <div className="delivery-options">
        <div className="delivery-title">Доставка до Москвы за 1 шт</div>
        <div className="delivery-list">
          {product.deliveries.map((option) => (
            <div className="delivery-item" key={option.id}>
              <div className="delivery-info">
                <div className="delivery-icon"><DeliveryIcon icon={option.icon}></DeliveryIcon></div>
                <div className="delivery-text">
                  <div className="delivery-name">{option.name}</div>
                  <div className="delivery-desc">до {option.day} дней</div>
                </div>
              </div>
              <div className="delivery-price">
                <div className='one-price'>{option.cost.toFixed(2)} $</div>
                <div className='weight-price'>{option.costWt.toFixed(2)} $/кг</div>
                
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="quantity-cart btn-container-fixed">
      {inCart ? (
        <>
          <button className="cart-button btn btn-primary" onClick={() => {openModal()}}>
            <div className="title">В корзине</div>
            <div className="sub">Перейти</div>
          </button>

          <div className="stepper">
            <button className="stepper-btn btn btn-secondary" onClick={decrease}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 12C5 11.4477 5.44772 11 6 11L18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13L6 13C5.44772 13 5 12.5523 5 12Z" fill="white"/>
              </svg>
            </button>
            <input
              type="number"
              min="1"
              value={quantity}
              onChange={handleQuantityChange}
              className="stepper-value"
            />
            <button className="stepper-btn btn btn-secondary" onClick={increase}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5Z" fill="white"/>
              </svg>
            </button>
          </div>
        </>
        ) : (
          <>
            <div className="input-box" style={{maxHeight: "56px"}}>
              <label className="label">Количество</label>
              <input
                type="number"
                className="input"
                value={quantity}
                min={1}
                onChange={(e) => {
                  const val = e.target.value;

                  if (val === "") {
                    setQuantity("");
                    return;
                  }

                  const number = parseInt(val, 10);
                  if (!isNaN(number) && number > 0) {
                    setQuantity(number);
                  }
                }}
              />
            </div>

            <button className="add-button btn btn-primary" onClick={handleAddToCart}>
              <div className="title">В корзину</div>
              <div className="sub">{quantity} шт</div>
            </button>
          </>
        )}
      </div>
      </>
      )}
      
    </div>
  );
};

export default ProductPage;
